window.CCBWQA = window.CCBWQA || {};

(function () {
  // Initialize time series variables
  let dailyAvgTimeSeries;
  let daily15MinTimeSeries;

  // Create filters
  const startDate = createFilter('date', 'Start Date');
  const endDate = createFilter('date', 'End Date');
  const parameter = createFilter('dropdown', 'Parameter');

  if (window.CCBWQA.alternateStreamLogger) {
    startDate.setDate('2019-10-01');
    endDate.setDate('2020-09-30');
  } else if (
    window.CCBWQA.alternateStreamLogger2021 ||
    window.CCBWQA.alternateStreamLogger2021Precipitation ||
    window.CCBWQA.alternateStreamLogger2021PrecipitationAndTemp
  ) {
    startDate.setDate('2023-10-01');
    endDate.setDate('2024-09-30');
  } else if (
      window.CCBWQA.alternateStreamLogger2022 ||
      window.CCBWQA.alternateStreamLogger2022Precipitation ||
      window.CCBWQA.alternateStreamLogger2022PrecipitationAndTemp
  ) {
    startDate.setDate('2021-10-01');
    endDate.setDate('2022-09-30');
  }
  else if (
    window.CCBWQA.alternateStreamLogger2023 ||
    window.CCBWQA.alternateStreamLogger2023Precipitation ||
    window.CCBWQA.alternateStreamLogger2023PrecipitationAndTemp
  ) {
    startDate.setDate('2022-10-01');
    endDate.setDate('2023-09-30');
  }
  else if (
    window.CCBWQA.alternateStreamLogger2024 ||
    window.CCBWQA.alternateStreamLogger2024Precipitation ||
    window.CCBWQA.alternateStreamLogger2024PrecipitationAndTemp
  ) {
    startDate.setDate('2023-10-01');
    endDate.setDate('2024-09-30');
  }
  else {
    startDate.setDate('2021-10-01');
    endDate.setDate('2022-09-30');
  }

  // store filters in an array
  const filters = [startDate, endDate, parameter];

  // create request for parameter dropdown
  const parameterURL = createRequestURL({
    url: '/sites/all/scripts/view/',
    table: 'viewer.download_dropdown_params_logger_with_weather',
    fields: ['*'],
  });

  // create request for daily averages data
  const dailyRequestURL = createRequestURL({
    url: '/sites/all/scripts/view/',
    table: 'viewer.stream_logger_results_viewer_daily_stats_table',
    fields: ['*'],
  });

  // create request for 15 minute data
  const daily15minRequestURL = createRequestURL({
    url: '/sites/all/scripts/view/',
    table: 'viewer.stream_logger_results_viewer_15_min_table',
    fields: ['*'],
  });

  // fetch data and create promises for data requests
  const parameterPromise = fetchData(parameterURL);
  const resultsPromise = fetchDataResults(dailyRequestURL);
  const resultsPromise2 = null; //fetchDataResults(daily15minRequestURL);

  /**
   * This function is used to filter the data using
   * the users selected start date, end date, and parameter
   * @param {Array} data
   * @return {Array} filtered data
   */
  function filterData(data) {
    const startDateVal = startDate.getDate();
    const endDateVal = endDate.getDate();
    const parameterVal = parameter.val();
    return data.filter(
      d =>
        d.parameterid == parameterVal &&
        moment(d.rdate).isSameOrAfter(startDateVal) &&
        moment(d.rdate).isSameOrBefore(endDateVal) &&
        d.daily_average !== null
    );
  }

  /**
   * This function is used to format the data for time series graphs
   * @param  {array} data        [data to format]
   * @param  {string} resultField [the name of the field that contains the results to display]
   * @param  {string} dateField   [the name of the field that contains the date value]
   * @return {array}             [returns an array of formatted data]
   */
  function formatDailyData(data, fields) {
    return data.map(d => {
      return {
        rdate: d[fields.rdate],
        rvalue: d[fields.rvalue],
        min_value: d[fields.min_value],
        max_value: d[fields.max_value],
        location_name: d.location_name,
        unit_name: d.result_unit_name,
        parameterid: d.parameterid,
      };
    });
  }

  /**
   * This function is used to format the data for time series graphs
   * @param  {array} data        [data to format]
   * @param  {string} resultField [the name of the field that contains the results to display]
   * @param  {string} dateField   [the name of the field that contains the date value]
   * @return {array}             [returns an array of formatted data]
   */
  function format15minData(data, fields) {
    return data.map(d => {
      return {
        rdate: d[fields.rdate],
        rvalue: d[fields.rvalue],
        location_name: d.location_name,
        unit_name: d.result_unit_name,
        parameterid: d.parameterid,
      };
    });
  }

  function validateProps(props, obj, msg = 'Error: Please resolve the following:') {
    let errors = props
      .map(prop => {
        if (typeof obj[prop] === 'undefined') {
          return `No value provided for the ${prop} property \n`;
        }
        return 0;
      })
      .filter(prop => prop !== 0);
    if (errors.length > 0) {
      throw `${msg} \n ${errors.join('')}`;
    }
  }

  function createRequestURL(req = {}) {
    validateProps(['url', 'table', 'fields'], req, 'Error creating the daily request url:');
    const { url, table, fields } = req;
    return `${url}?table=${table}&fields%5b%5d=${fields}&drupal_user_switch=false&drupal_userid=1`;
  }

  /**
   * This function is used as shorthand for creating a Mercury Form filter control
   * @param  {string} type  [type of filter to create i.e. dropdown or date filter]
   * @param  {string} label [label to display above filter]
   * @return {object}       [returns a mercury form object]
   */
  function createFilter(type, label) {
    let options = {
      parentContainer: '#filters-wrapper',
      label: label,
    };

    if (type === 'date') {
      return new datePicker(options);
    } else if (type === 'dropdown') {
      return new Dropdown(options);
    }
  }

  function updateGraphTitles(parameter, date) {
    const dailyAverageTitle = document.querySelector('#daily-graph-title');
    const daily15minTitle = document.querySelector('#daily-15-min-graph-title');
    const summaryDataTitle = document.querySelector('#summary-data-title');
    dailyAverageTitle.textContent = `Daily Average ${parameter} Values Over Time`;

    if (typeof date !== 'undefined') {
      daily15minTitle.textContent = `15 Minute ${parameter} Data on ${date}`;
      summaryDataTitle.textContent = `Summary Data for ${date}`;
    } else {
      daily15minTitle.textContent = `15 Minute ${parameter} Data`;
      summaryDataTitle.textContent = `Summary Data`;
    }
  }

  /**
   * This function is used to bind the onChange event for each filter
   * The function loops through each filter and binds the createResultRequest function to the filter
   * @return {[type]} [description]
   */
  function bindFilterEvents(data) {
    const filters = [startDate, endDate, parameter];

    filters.forEach(filter => {
      filter.onChange = () => {
        dailyAvgTimeSeries.removeTable(
          '<tr><td class="text-center" colspan="4">Click on a date along the line in the daily averages graph to view summary data for a specific day.</td></tr>'
        );
        if (typeof daily15MinTimeSeries !== 'undefined') {
          daily15MinTimeSeries.removeSVG(
            '<p class="margin-left alert alert-success col-sm-5">Click on a date along the line in the daily averages graph to view 15 minute data for a specific day.</p>'
          );
        }
        const filteredData = filterData(data);
        console.log(filteredData);

        if (filteredData && filteredData.length > 0) {
          drawDailyAvgTimeSeries(filteredData);
          updateGraphTitles(filteredData[0].parameter);
        }
      };
      filter.bindEvents();
    });
  }

  // Create an async function as a shorthand for resolving fetch requests
  async function fetchData(url) {
    let response = await fetch(url);
    let json = await response.json();

    return json;
  }

  async function fetchDataResults(url) {
    try {
      let response = await fetch(url);
      let json = await response.json();
      if (window.CCBWQA.alternateStreamLogger || window.CCBWQA.alternateStreamLogger2021 || window.CCBWQA.alternateStreamLogger2022 || window.CCBWQA.alternateStreamLogger2023|| window.CCBWQA.alternateStreamLogger2024) {
        json = json.filter(x => x.location_name === 'CT-2' || x.location_name === 'CC-10');
      }

      json = json.map(x => {
        if (x.location_name === 'MHFD 10091') {
          return { ...x, location_name: 'MHFD Cherry Ck' };
        } else if (x.location_name === 'NCDC USW00093067') {
          return { ...x, location_name: 'NOAA KAPA' };
        } else if (x.location_name === 'MHFD 10091 Max') {
          return { ...x, location_name: 'MHFD Cherry Ck Max' };
        } else if (x.location_name === 'NCDC USW00093067 Max') {
          return { ...x, location_name: 'NOAA KAPA Max' };
        }
        if (x.location_name === 'MHFD 10091 Min') {
          return { ...x, location_name: 'MHFD Cherry Ck Min' };
        } else if (x.location_name === 'NCDC USW00093067 Min') {
          return { ...x, location_name: 'NOAA KAPA Min' };
        } else {
          return x;
        }
      });

      //MJB adding this restriction on 1/18/21 for the newest AP per Carolyn
      // else {
      //   json = json.filter(x => x.location_name === 'CT-2' || x.location_name === 'CC-10');
      // }
      return json;
    } catch (err) {
      console.log(err);
    }

    return null;
  }

  function drawDailyAvgTimeSeries(data) {
    dailyAvgTimeSeries = new LoggerTimeSeries({
      parameterId: parameter.val(),
      container: '#daily-avg-graph',
      data: formatDailyData(data, {
        rdate: 'rdate',
        rvalue: 'daily_average',
        min_value: 'daily_min',
        max_value: 'daily_max',
      }),
      aggregationLevel: 'daily',
      heightScale: 0.3,
      widthScale: 1,
      // create15MinDisplay: date => {
      //   resultsPromise2
      //     .then(data => {
      //       const filteredData = data.filter(
      //         d => d.parameterid == parameter.val() && moment(d.rdate).isSame(date, 'day')
      //       );
      //       updateGraphTitles(filteredData[0].parameter, moment(`${filteredData[0].rdate}`).format('MM/DD/YYYY'));
      //       draw15MinTimeSeries(filteredData);
      //     })
      //     .catch(err => {
      //       if (err) throw err;
      //     });
      // },
    });
    dailyAvgTimeSeries.draw();
  }

  // function draw15MinTimeSeries(data) {
  //   daily15MinTimeSeries = new LoggerTimeSeries({
  //     container: '#daily-15-min-graph',
  //     data: format15minData(data, {
  //       rdate: 'rtimestamp',
  //       rvalue: 'result_value',
  //     }),
  //     xAxis: { format: 'timestamp' },
  //     aggregationLevel: '15 min',
  //   });
  //   daily15MinTimeSeries.draw();
  // }

  parameterPromise.then(data => {
    let paramsToInclude = [8, 2, 1901];
    if (window.CCBWQA.alternateStreamLogger || window.CCBWQA.alternateStreamLogger2021 || window.CCBWQA.alternateStreamLogger2022 || window.CCBWQA.alternateStreamLogger2023 || window.CCBWQA.alternateStreamLogger2024) {
      paramsToInclude = [2, 1901];
    } else if (window.CCBWQA.alternateStreamLogger2021Precipitation || window.CCBWQA.alternateStreamLogger2022Precipitation || window.CCBWQA.alternateStreamLogger2023Precipitation || window.CCBWQA.alternateStreamLogger2024Precipitation) {
      paramsToInclude = [1908];
    } else if (window.CCBWQA.alternateStreamLogger2021PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2022PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2023PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2024PrecipitationAndTemp) {
      paramsToInclude = [1908, 1906];
    }
    // else {
    //MJB adding this restriction on 1/18/21 for the newest AP per Carolyn
    // paramsToInclude = [2, 1901];
    // }
    let filteredParams = data.filter(d => paramsToInclude.includes(d.stored));
    parameter.data = filteredParams;

    if (
      window.CCBWQA.alternateStreamLogger2021Precipitation ||
      window.CCBWQA.alternateStreamLogger2021PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2022Precipitation ||
        window.CCBWQA.alternateStreamLogger2022PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2023Precipitation ||
      window.CCBWQA.alternateStreamLogger2023PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2024Precipitation ||
      window.CCBWQA.alternateStreamLogger2024PrecipitationAndTemp
    ) {
      parameter.buildDropdown().val(1908);
    } else {
      parameter.buildDropdown().val(2);
    }

    // Request initial data from the DB
    resultsPromise
      .then(data => {
        let filteredData = filterData(data);
        if (
          window.CCBWQA.alternateStreamLogger2021Precipitation || 
          window.CCBWQA.alternateStreamLogger2021Precipitation ||
          window.CCBWQA.alternateStreamLogger2021PrecipitationAndTemp || window.CCBWQA.alternateStreamLogger2022Precipitation ||
            window.CCBWQA.alternateStreamLogger2022Precipitation ||
            window.CCBWQA.alternateStreamLogger2022PrecipitationAndTemp
          || window.CCBWQA.alternateStreamLogger2023Precipitation ||
          window.CCBWQA.alternateStreamLogger2023Precipitation ||
          window.CCBWQA.alternateStreamLogger2023PrecipitationAndTemp
          || window.CCBWQA.alternateStreamLogger2024Precipitation ||
          window.CCBWQA.alternateStreamLogger2024Precipitation ||
          window.CCBWQA.alternateStreamLogger2024PrecipitationAndTemp
        ) {
          filteredData = filteredData.filter(d => d.parameterid === 1908 && d.daily_average !== null);
        } else {
          filteredData = filteredData.filter(d => d.parameterid === 2 && d.daily_average !== null);
        }
        drawDailyAvgTimeSeries(filteredData);
        bindFilterEvents(data);
      })
      .catch(err => {
        if (err) throw err;
      });
  });
})();
